//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PartFamily.js";
import "../no/NXObject.js";
let d=[[[0,"TemplateName",0,0],[0,"Version",0,0]],[[["numOfAttrs"],"GetAttributes",{R_:{templateAttrs:"PartFamily.FamilyAttribute[]"}},0,0],[["attr","numOfValidValues"],"GetValidAttributeValues",{R_:{validAttrValues:""}},1,0],[["memberCount","members"],"GetMembers",{},0,0],[["memberName"],"IsValidMemberName",{R_:{isValidMemberName:''}},1,0]],[]];
SPLM.PartFamily.Template = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PartFamily.Template";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;